import { computed, get } from '@ember/object';
import takeFromArray from '@intercom/pulse/lib/take';

export default function take(arrayKey, length) {
  return computed(function () {
    return takeFromArray(get(this, arrayKey), length);
  });
}
